module.exports = __webpack_public_path__ + "img/KSC01354.0fb3d4e4.jpg";